import './Admin.scss'
import React, {Component} from 'react'
import { withTranslation } from 'react-i18next'
import {Modal, Tabs} from 'antd'
import { Page, PageBottomBar, PageContent, PageFooter, PageHeader, PageTopBar } from '../../layouts/Private/components'

import {
  AdminUsersPage,
  AdminAuditPage,
  AdminSearchPage,
  AdminConsultasPage,
  AdminLogBasesPage,
  AdminListsPage,
  AdminAuthIpsPage,
  AdminRiskPage,
  AdminGroupsPage, AdminTransFilePage, AdminFormManagerPage
} from '../'

const { TabPane } = Tabs

class Admin extends Component {
  state = {
    breadcrumbs: this.getBreadcrumbs(),
    activeTabKey: "1",
    nextTabKey: null,
    isConfirmVisible: false,
    formHasChanges: false
  }

  getBreadcrumbs() {
    const { t } = this.props

    const breadcrumbs = [
      {
        title: t('messages.aml.administration'),
        icon: 'file-search',
        link: '/administracion'
      },
    ]

    return breadcrumbs
  }

  //manejo comportamiento cambio por pestaña
  handleTabChange = (currentKey) => {
    const { activeTabKey, formHasChanges} = this.state
    if (activeTabKey === "9" && currentKey !== "9" && formHasChanges) {
      this.setState({nextTabKey: currentKey})
      this.setState({isConfirmVisible: true})

    }else{
      this.setState({activeTabKey: currentKey});
    }
  };
  handleConfirmChange = () => {
    const{nextTabKey} = this.state
    this.handleUnsavedChanges(false)
    this.setState({isConfirmVisible: false})
    this.setState({activeTabKey: nextTabKey});


  };
  handleCancelChange = () => {
    this.setState({isConfirmVisible: false});
    this.setState({nextTabKey: null});
  };

  handleUnsavedChanges = (value) => {
    const hasChanges = value === true ? value : false
      this.setState({formHasChanges: hasChanges })
  }

  render() {
    const { breadcrumbs , isConfirmVisible, formHasChanges} = this.state
    const { currentUser, protectedContent, t } = this.props

    return (
      <div className="admin-page">
        <PageTopBar breadcrumbs={ breadcrumbs } />
        <Page>
          <PageHeader
            title={ protectedContent === 'contenidos' ? t('messages.aml.contentPageTitle') : t('messages.aml.administrationPageTitle') }
            description={ protectedContent === 'contenidos' ? t('messages.aml.contentPageDescription') : t('messages.aml.administrationPageDescription')}
            icon="file-search"
            />
          <PageContent>
            <Tabs
                defaultActiveKey={
                  protectedContent === 'admin'
                    ? "1"
                    : (currentUser.cliente.modules.includes('NEG') && currentUser.modules && currentUser.modules.includes('LOADNEG'))
                      ? "6"
                      : (currentUser.cliente.modules.includes('AUTH-SEARCH') && currentUser.modules && currentUser.modules.includes('OFCTO'))
                        ? "12"
                        : "10"
                }
                type="card"
                //activeKey={activeTabKey}
                onChange={this.handleTabChange}
            >

              { protectedContent === 'admin' && !currentUser.cliente.modules.includes('CONSULTA2') &&
              <TabPane tab={ t('messages.aml.users') } key="1" onChange={this.handleTabChange.bind(this)} >
                <AdminUsersPage currentUser={ currentUser } />
              </TabPane>
              }
              { protectedContent === 'admin' && 
                <TabPane tab={ t('messages.aml.auditTitle') } key="2">
                  <AdminAuditPage currentUser={ currentUser } />
                </TabPane>
              }
              { protectedContent === 'admin' && (currentUser.cliente.planBatch !== null || currentUser.cliente.planHist !== null) &&
                <TabPane tab={ t('messages.aml.searches') } key="3">
                  <AdminSearchPage currentUser={ currentUser } />
                </TabPane>
              }
              { protectedContent === 'admin' 
                && (currentUser.cliente.planBatch !== null || currentUser.cliente.planHist !== null)
                && (currentUser.type === 'SADMIN' || currentUser.type === 'ADMIN') 
                && currentUser.modules && currentUser.modules.includes('CONSULTAS') &&
                <TabPane tab={ t("messages.aml.admin.query") } key="4">
                  <AdminConsultasPage currentUser={ currentUser } />
                </TabPane>
              }
              { protectedContent === 'admin' && currentUser.type === 'SADMIN' && currentUser.cliente.modules.includes('PFA') &&
                <TabPane tab={ t("messages.aml.admin.log") } key="5">
                  <AdminLogBasesPage currentUser={ currentUser }/>
                </TabPane>
              }

              { protectedContent === 'contenidos' && currentUser.cliente.modules.includes('NEG') && currentUser.modules && currentUser.modules.includes('LOADNEG') &&
                <TabPane tab={ t('messages.aml.ownLists') } key="6">
                  <AdminListsPage currentUser={ currentUser } />
                </TabPane>
              }
              { protectedContent === 'admin' 
                && (currentUser.type === 'SADMIN' || currentUser.type === 'ADMIN') 
                && currentUser.modules && currentUser.modules.includes('ADMRISK') &&
                <TabPane tab={ t('messages.aml.risk') } key="7">
                  <AdminRiskPage currentUser={ currentUser} />
                </TabPane>
              }
              { protectedContent === 'admin' && currentUser.type === 'SADMIN' && currentUser.cliente.modules.includes('REGISTRO') &&
                <TabPane tab={ t('messages.aml.groups') } key="8">
                  <AdminGroupsPage currentUser={ currentUser } />
                </TabPane>
              }
              { protectedContent === 'admin' && currentUser.type === 'SADMIN' &&
                <TabPane tab={ t('messages.aml.parameters') } key="9">
                  <AdminAuthIpsPage currentUser={ currentUser } handleUnsavedChanges={ this.handleUnsavedChanges.bind(this)} />
                </TabPane>
              }
              { protectedContent === 'contenidos' && currentUser.cliente.modules.includes('TRANS_FILES')
                  && currentUser.modules && currentUser.modules.includes('USER_TRANS_FILE') &&
                  <TabPane tab={ t('messages.aml.file.transfer') } key="10">
                    <AdminTransFilePage currentUser={ currentUser } />
                  </TabPane>
              }
              { protectedContent === 'contenidos' && (currentUser.cliente.modules.includes('CDI-FORM') || currentUser.cliente.modules.includes('ONBOARDING'))
                && currentUser.cliente.modules.includes('FORM-MANAGER')
                && (currentUser.modules && currentUser.modules.includes('FORM-MANAGER')) &&
                  <TabPane tab={ t('messages.aml.form.manager') } key="11">
                    <AdminFormManagerPage currentUser={ currentUser } />
                  </TabPane>
              }
              { protectedContent === 'contenidos'
                && currentUser.cliente.modules.includes('AUTH-SEARCH')
                && currentUser.modules
                && currentUser.modules.includes('OFCTO') &&
                  <TabPane tab={ t('messages.aml.authorization') } key="12">
                    <AdminSearchPage currentUser={ currentUser } modulo="auth-search" />
                  </TabPane>
              }
            </Tabs>

            {formHasChanges && <Modal
                title="Confirmación"
                visible={isConfirmVisible}
                onOk={this.handleConfirmChange.bind(this)}
                onCancel={this.handleCancelChange.bind(this)}
                okText="Salir sin guardar"
                cancelText="Continuar"
            >
              <p>  Tienes cambios sin guardar. Si continúas, los cambios realizados se perderán. ¿Estás seguro de que deseas continuar? </p>
            </Modal>}

          </PageContent>
          <PageFooter>

          </PageFooter>
        </Page>
        <PageBottomBar breadcrumbs={ breadcrumbs } />
      </div>
    )
  }
}

export default withTranslation()(Admin)
